// extracted by mini-css-extract-plugin
export default {"button":"SentenceGenerateButton_button__ZxhmG","icon":"SentenceGenerateButton_icon__rPOfH"};